import React from 'react';
import { Box, Paper } from '@mui/material';
import NavBar from './NavBar/index.js';
import Footer from './Footer';
import useMdUpScreen from '../hooks/useMdUpScreen';
import BackgroundImageBox from '../components/BackgroundImageBox';
import Errors from '../components/Errors';
import BackgroundImage from '../components/BackgroundImage';
import useChangeBackground from '../hooks/useChangeBackground';
import config from '../config';
import ConfigMenu from './ConfigMenu.js';
import Theme from './Theme.js';
import { useThemeStatics } from '../hooks/useThemeConfig.js';

const { debugMode } = config;

function CardLayout({ children, extraBackground = false, extraBackgroundSx={}, heightAdjust = false }) {
  const mdUpScreen = useMdUpScreen();
  return (<Theme>
    <Box sx={{ 
      flexGrow: 1,
      display: 'flex',
      flexFlow: 'column',
      height: heightAdjust ? '100%' : '100vh'
    }}>
      <NavBar />
      <Box sx={{ height: '100%', backgroundColor: 'surfaces.light' }}>
        <Box sx={{ height: mdUpScreen ? '57px' : '50px' }} />
        <Box sx={{ height: 'auto', width: '100%', mt: 0, mx: 0 }} >
          {children}
        </Box>
      </Box>
      {/*<ConfigMenu />*/}
      <Footer />
      {debugMode && (<Errors />)}
    </Box>
  </Theme>);
}

function ImageTransparentLayout({ children, extraBackground = false, extraBackgroundSx={}, heightAdjust = false }) {
  const staticConfig = useThemeStatics();
	const { homeUrl, imageFromHomeUrl, bannerMobileList, carrouselBannerParams: { background1: b1, background2: b2 }, styles: { border } } = staticConfig;
  const bannerMobile = (imageFromHomeUrl ? homeUrl : '') + bannerMobileList[0];
  const mdUpScreen = useMdUpScreen();
  const paperSx = mdUpScreen ? {
    height: 'auto', width:'100%', mt: 0
  } : {
    height: 'auto', width: '100%', my: 2,
  };
  const background1Src = useChangeBackground(b1.ini, b1.fin, b1.segundos);
  const background2Src = useChangeBackground(b2.ini, b2.fin, b2.segundos);
  return (<Theme>
    <Box sx={{ 
      flexGrow: 1,
      display: 'flex',
      flexFlow: 'column',
      height: heightAdjust ? '100%' : '100vh',
      backgroundColor: 'surfaces.light'
      // height: '100vh'
    }}>
      <NavBar />
      <Box sx={{ height: mdUpScreen ? '57px' : '50px' }} />
      <Box sx={{ height: '100%' }}>
        <Box sx={{ height: 'auto', width: '100%', mt: 0, mx: 0 }} >
        <Paper elevation={3} sx={{ ...paperSx, mx: 'auto' }} >
          <BackgroundImageBox src={mdUpScreen ? background1Src : bannerMobile} top="0%" >
            {children}
          </BackgroundImageBox>
        </Paper>
        </Box>
      </Box>
      {/*<ConfigMenu />*/}
      {extraBackground && (<BackgroundImage src={background2Src} sx={extraBackgroundSx} />)}
      <Footer />
      {debugMode && (<Errors />)}
    </Box>
  </Theme>);
}

export default function Layout({ children, ...rest }) {
  const layoutType = rest.type;
  const isTransparent = layoutType === 'transparent';
  return isTransparent ? 
    (<ImageTransparentLayout  {...rest}>{children}</ImageTransparentLayout>)
    :
    (<CardLayout {...rest}>{children}</CardLayout>);
}